import { Footer } from "../components/Footer";
import Header from "../components/Header";
import {useLoaderData} from "@remix-run/react";
import { useEffect } from "react";
import { getPage } from "../controllers/pages";
import { IMG_URL } from "../helpers/def";
import { NavLink } from "@remix-run/react";
import {ContactForm} from "../components/ContactForm";
import { sendContactMail } from "../controllers/sendContactMail";
import { getTwoNews } from "../controllers/news";
import { json } from "@remix-run/node";
//styles
import styles1 from '~/assets/css/uikit.min.css';
import styles2 from '~/assets/css/slick.css';
import styles3 from '~/assets/css/slick-theme.css';
import styles4 from '~/assets/css/ion.rangeSlider.css';
import styles5 from '~/assets/css/main.css';
const mongoose =require('mongoose');
const useScript = (src,condition) => {  
    useEffect(() => {
            const tag = document.createElement('script');
            tag.async = condition;
            tag.src = src;
            document.body.appendChild(tag);            
            return () => {
              document.body.removeChild(tag);
            }      
    }, [src])  
  }
export default function iletisim(){
    useScript('/assets/js/jquery.min.js',false);
  useScript('/assets/js/uikit.min.js',false);
  useScript('/assets/js/uikit-icons.min.js',false);
  useScript('/assets/js/fontawesome.all.min.js',false);
  useScript('/assets/js/slick.min.js',false);
  useScript('/assets/js/ion.rangeSlider.min.js',false);
  useScript('/assets/js/main.js',false);
  const data =useLoaderData();  
  const sliderImage = {
    backgroundImage: 'url('+IMG_URL+'mc/1920/950/6/sliders/'+data?.page.slider.split('æ')[0]+')'
    }  
    return(
        <div className="page-wrapper">
        <Header />
        <main className="page-main">
      <div className="section-hero">
        <div className="section-hero__bg" style={sliderImage}>
          <div className="uk-container">
            <div className="section-hero__content">
              <div className="section-hero__title"> <span>{data?.page.slider.split('æ')[1]}</span>
                <div className="uk-h1">{data?.page.slider.split('æ')[2]}</div>
              </div>
              <div className="section-hero__breadcrumb">
                <ul className="uk-breadcrumb">
                  <li><NavLink to="/">Ana Sayfa</NavLink></li>
                  <li> <span>İletişim</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="contact-map">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3205.342872242503!2d32.0218546!3d36.5458449!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14dc9968156b82bd%3A0x41f094f2b32c3988!2sHonda%20Alanya%20Motor!5e0!3m2!1str!2str!4v1679180015614!5m2!1str!2str" width="100" height="50" style={{border:1}} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>

      </div>
      <div className="page-content">
        <div className="uk-section-large uk-container">
          <div className="contact-info">

            <div className="contact-info-title">{data.gallery}</div>
            <div className="uk-grid uk-grid-divider uk-child-width-1-4@m uk-child-width-1-2@s" data-uk-grid>
              <div>
                <div className="contact-info-item">
                  <div className="contact-info-item__icon"><img src="assets/img/icons/contact-icon-1.png" alt="contact-icon"/></div>
                  <div className="contact-info-item__title">Müşteri Hizmetleri</div>
                  <div className="contact-info-item__value"> <a href="tel:00902425254050">0 242 525 40 50</a></div>
                </div>
              </div>
              <div>
                <div className="contact-info-item">
                  <div className="contact-info-item__icon"><img src="assets/img/icons/contact-icon-2.png" alt="contact-icon"/></div>
                  <div className="contact-info-item__title">Çalışma Saatleri</div>
                  <div className="contact-info-item__value">Pazartesi - Cumartesi 08:30 - 18:00</div>
                </div>
              </div>
              <div>
                <div className="contact-info-item">
                  <div className="contact-info-item__icon"><img src="assets/img/icons/contact-icon-3.png" alt="contact-icon"/></div>
                  <div className="contact-info-item__title">E-Posta Adresi</div>
                  <div className="contact-info-item__value"> <a href="mailto:bilgi@alanyamotor.com">bilgi@alanyamotor.com</a></div>
                </div>
              </div>
              <div>
                <div className="contact-info-item">
                  <div className="contact-info-item__icon"><img src="assets/img/icons/contact-icon-4.png" alt="contact-icon"/></div>
                  <div className="contact-info-item__title">Showroom Adres</div>
                  <div className="contact-info-item__value">Fığla Mah. Bağcı Cad. No:4<br/> 07460 Alanya</div>
                </div>
              </div>
            </div>
          </div>
         <ContactForm />
        </div>
      </div>
    </main>
        <Footer news={data.news} />          
    </div>
    
        
    )
}
export const loader= async () => {  
    await mongoose.connect(process.env.DATABASE_URL);
    const [page,news] = await Promise.all([
      getPage(2),
      getTwoNews()     
   ]);
   return json({ page,news});
  }
  export function meta({data}){
     return{
      title:data.page.title,
      description:data.page.seoD,
      keywords:data.page.seoK
    };
  }
  export async function action({request}){
    const formData=await request.formData();
    const messageData=Object.fromEntries(formData);
    const result= await sendContactMail(messageData,1);
    return true;
    }
    export function links(){
      return [
        {rel:'stylesheet',href:styles1},
        {rel:'stylesheet',href:styles2},
        {rel:'stylesheet',href:styles3},
        {rel:'stylesheet',href:styles4},
        {rel:'stylesheet',href:styles5}
      ]
    }